import React from 'react'
import {Font} from "../../../../types/Font";
import cx from "classnames";
import styles from "./DeleteFontModalContent.module.css";
import Text from "../../../../components/Text";
import Button from "../../../../components/Button";
import {useTranslation} from "react-i18next";
import {useGlobalContext} from "../../../../contexts/globalContext";
import {useDeleteData} from "../../../../hooks/useDeleteData";

const DeleteFontModalContent: React.FC<{font: Font, onSubmit: () => void}> = ({font, onSubmit}) => {
    const { t } = useTranslation(['settings'])
    const {closeModal, showToast} = useGlobalContext()
    const { submit } = useDeleteData('fonts', font.id)

    const handleSubmit = () => {
        submit().then((res) => {
            if (res.status === 204) {
                closeModal()
                showToast('top-right', 'success', t('fonts.delete_modal.success'))
            } else {
                showToast('top-right', 'error', t('fonts.delete_modal.error'))
            }
            onSubmit()
        })
    }

    const handleAbort = () => {
        closeModal()
    }

    return (
        <div className={cx(styles['modal-wrapper'])}>
            <Text>{t('fonts.delete_modal.sub_heading', {font_name: font.name})}</Text>
            <Button
                hierarchy={'primary'}
                text={t('fonts.delete_modal.delete')}
                fn={() => handleSubmit()}
                classes={'w-100 mx-4 my-2'}
            />
            <Button
                hierarchy={'secondary'}
                text={t('common.abort')}
                fn={() => handleAbort()}
                classes={'w-100 mx-4 my-2'}
            />
        </div>
    )
}

export default DeleteFontModalContent
